import { MAX_QUANTITY, MIN_QUANTITY } from '../constants'

export const sanitizeQuantity = (value: number) =>
  Math.min(MAX_QUANTITY, Math.max(MIN_QUANTITY, value || MIN_QUANTITY))
